import React from 'react';
import { Row } from 'react-table';
import Checkbox from '@alltrails/shared/components/checkboxes/Checkbox24';

import { useSelector } from '../../../redux/hooks';
import { selectEditing } from '../../../redux/slices/alertsDrawer/alertsDrawer';
import * as styles from './styles/styles.module.scss';

type SelectedColumnProps = {
  row: Row;
};

const SelectedColumn = ({ row }: SelectedColumnProps): JSX.Element => {
  const { checkbox: trailId } = row.values;
  const { onChange, checked } = row.getToggleRowSelectedProps();
  const editingAlert = useSelector(selectEditing);
  return (
    <Checkbox
      id={`selected-${trailId}`}
      className={styles.selectCell}
      name=""
      disabled={editingAlert}
      checked={checked}
      value=""
      onChange={onChange}
    />
  );
};

export default SelectedColumn;
